import React from 'react';
import { FormField } from '../types/form';
import { isHeaderOptions } from '../types/guards';

interface HeaderFieldProps {
  field: FormField;
  className?: string;
}

export const HeaderField: React.FC<HeaderFieldProps> = ({ field, className }) => {
  const fontSize = (field.options && isHeaderOptions(field.options)) ? field.options.fontSize || 'medium' : 'medium';
  
  const getFontSizeClass = () => {
    switch (fontSize) {
      case 'small':
        return 'text-lg font-medium';
      case 'large':
        return 'text-3xl font-bold';
      case 'medium':
      default:
        return 'text-2xl font-semibold';
    }
  };

  return (
    <div className={className}>
      <h2 className={`${getFontSizeClass()} text-foreground mb-2`}>
        {field.label}
      </h2>
    </div>
  );
};